<div class="h-full">
  <ng-container *ngIf="bankMode === 'select'; else add">
    <app-bank-account-select
      [labels]="labels"
      [optionConfig]="optionConfig"
      [selectedBankAccount]="selectedBankAccount"
      (changeBankModeEvent)="changeBankMode($event)"
      (changeSelectedBankEvent)="changeSelectedBank($event)"
      (onContinueEvent)="emitBankSendValidateEvent()"
    ></app-bank-account-select>
  </ng-container>
  <ng-template #add>
    <app-bank-account-add
      [labels]="labels"
      [bankGFFPFields]="bankGFFPFields"
      (submitBankAccountEvent)="addNewBankAccount($event)"
    ></app-bank-account-add>
  </ng-template>
</div>

